// GI31 일반출고 서비스 레이어 상수.
// 화면(pages) 쪽 consts 와 나누는 이유는 services 가 pages 를 참조하면 계층이 뒤집히기 때문이다.

/**
 * 저장 진행률 폴링 간격.
 *
 * 1.0 이 GI31·GI35 저장 후 `openProgressModal({ pollingInterval: 10000 })` 로 넘기던 값과 같다
 * (moms-fe-1.0 `store/modules/grid.js` saveEpic). 더 짧게 잡으면 같은 작업에 서버를 세 배로 두드린다.
 */
export const OUTBOUND_PROGRESS_POLLING_INTERVAL_MS = 10000

/**
 * 연속 실패 상한. 이만큼 실패하면 폴링을 멈춘다.
 *
 * 상한이 없으면 엔드포인트가 죽었을 때 사용자가 화면을 떠날 때까지 계속 두드린다.
 * 응답이 안 오면 `status` 가 undefined 라 끝난 상태 판정에 걸리지 않기 때문이다.
 * 1.0 `progressPollingEpic` 의 `errorCount >= 5` 와 같은 값이고, 성공하면 카운트가 초기화되는 것도 같다
 * (React Query `fetchFailureCount` 가 성공 시 0 으로 돌아간다).
 */
export const OUTBOUND_PROGRESS_MAX_FAILURES = 5

/**
 * 폴링 최대 시도 횟수. 10초 간격이므로 약 10분이다.
 *
 * 실패 상한만으로는 부족하다. 워커가 죽어 진행률이 RUNNING 에 멈춘 채 200 을 계속 돌려주면
 * 응답이 정상이라 실패로 안 세고, 상태도 안 끝나 종료 판정에 걸리지 않는다. 그러면 화면을
 * 열어둔 내내 10초마다 두드린다. 1.0 은 모달을 사람이 닫아 끝났지만 이 화면은 모달이 없다.
 */
export const OUTBOUND_PROGRESS_MAX_ATTEMPTS = 60

/** 저장 진행률이 더 이상 바뀌지 않는 상태. 이 값이 오면 폴링을 멈춘다(moms-be OutboundProgressHelper). */
export const OUTBOUND_PROGRESS_TERMINAL_STATUSES = ['COMPLETED', 'FAILED'] as const

/** 조회 실패 폴백 문구 — BE 가 200 + rtnChk:false 로 거절하면서 문구를 비웠을 때. */
export const SEARCH_FAILED_MESSAGE = '조회 중 오류가 발생했습니다.'

/** 조회 한 번 크기 — BE `OutboundGeneralController.MAX_PAGE_SIZE`(10,000, 넘으면 조용히 잘린다). 전량은 이 크기로 끊어 받는다(LOGISPRD-15268). */
export const GENERAL_OUTBOUND_FETCH_SIZE = 10000

/** 화주 전건 조회 상한. 클라이언트 검색(showSearch) 전제로 한 번에 받는다(ST11 선례). */
export const SHIPPER_LIST_MAX_SIZE = 10000

/**
 * 화면(탭) 메뉴 코드. BE 메뉴 코드와 다르다 — 2.0 화면은 새 메뉴로 등록돼 `GI37` 이다.
 *
 * 목록 queryKey 에 넣는다. 탭을 닫을 때 `MenuOnSessionWrap.remove` 가 queryKey 에 메뉴 코드가 든
 * 캐시만 지우기 때문이다(같은 파일 주석: "쿼리 키에 메뉴 코드가 포함되어야 함").
 * 빼면 탭을 닫아도 조회 결과가 캐시에 남는다.
 *
 * **소문자다.** 탭 코드가 `useAuthQueries.ts:54` 에서 `MENU_CD.toLowerCase()` 로 만들어지고,
 * 캐시 삭제가 `queryKey.some((key) => key.includes(code))` 로 비교한다. 대문자로 넣으면 안 걸린다.
 * 위치는 상관없다 — 전 요소를 훑는다.
 */
export const SCREEN_MENU_CODE = 'gi37'

/** BE 가 구분하는 메뉴 코드. 조회와 저장·확정이 서로 다른 값을 쓴다(moms-be OutboundGeneralController). */
export const SEARCH_MENU_CODE = 'GI31_HEAD'
export const SAVE_MENU_CODE = 'GI31'
export const SAVE_ITEM_CODE = 'HEAD'

/** 진행률 상태값. 종료 판정이 이 두 값을 문자열 리터럴로 흩어 쓰지 않게 한 곳에 둔다. */
export const PROGRESS_COMPLETED = 'COMPLETED'
export const PROGRESS_FAILED = 'FAILED'

/** 일반출고 엑셀 다운로드(비밀번호 zip, LOGISPRD-15805) — `useExcelDownload` 로 부른다. 바디는 `GeneralOutboundDownloadParams`. */
export const GENERAL_OUTBOUND_DOWNLOAD_URL = '/api/v1/get-general-outbounds/download'
